export default __webpack_public_path__ + "scripts/resources/assignments/en/solubility/solutions.json";